const buildPayloadForPrice = (productId, optionDetails) => {
  const { siteId } = window.globalConfig;
  const transformedData = optionDetails.map((x) => {
    let transformedObject = {
      ChoiceId: x.choiceId,
      OptionId: x.optionId,
      ChoiceValue: x.choiceValue,
      OptionType: x.optionType,
      Tags: [],
    };

    if (x.optionId === 1) {
      transformedObject = {
        ...transformedObject,
        OptionType: 'Height',
      };
    }

    if (x.optionId === 2) {
      transformedObject = {
        ...transformedObject,
        OptionType: 'Width',
      };
    }
    return transformedObject;
  });
  return {
    SiteId: siteId,
    ProductId: productId,
    VariantId: 0,
    ProductLineId: 1,
    Choices: transformedData,
  };
};

export default buildPayloadForPrice;
